var Wdot;
(function (Wdot) {
    var AutocompleteHelper = (function () {
        function AutocompleteHelper() {
        }
        AutocompleteHelper.closeAutocomplete = function (itemSelected, textbox, event) {
            if (!itemSelected && textbox.value != "") {
                var autocomplete = $(textbox).data("ui-autocomplete");
                var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex($(textbox).val()), "i");
                autocomplete.widget().children(".ui-menu-item").each(function () {
                    //Check if each autocomplete item is a case-insensitive match on the input
                    var item = $(this).data("ui-autocomplete-item");
                    if (matcher.test(item.Name)) {
                        //There was a match, lets stop checking
                        autocomplete.selectedItem = item;
                        return false;
                    }
                });
                //if there was a match trigger the select event on that match
                //I would recommend matching the label to the input in the select event
                if (autocomplete.selectedItem) {
                    autocomplete._trigger("select", event, {
                        item: autocomplete.selectedItem
                    });
                    //there was no match, clear the input
                }
            }
        };
        return AutocompleteHelper;
    }());
    Wdot.AutocompleteHelper = AutocompleteHelper;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=AutoCompleteHelper.js.map